/* eslint-disable no-bitwise */
import * as marietta from '../../index';

export default class ColorUtil {
  // HEXの色をRGBに変換
  public static convertToRGB(color: string): marietta.webcad.collection.ColorRGB {
    let result: string = color.replace('#', '');
    if (result.length !== 6) {
      result = this.modifyHex(result);
    }
    return new marietta.webcad.collection.ColorRGB(parseInt(result.slice(0, 2), 16), parseInt(result.slice(2, 4), 16), parseInt(result.slice(4, 6), 16));
  }

  static modifyHex(value: string): string {
    let hex = value;
    if (hex.length === 4) {
      hex = hex.replace('#', '');
    }
    if (hex.length === 3) {
      hex = hex[0] + hex[1] + hex[1] + hex[2] + hex[3];
    }
    return hex;
  }

  /**
   * RGBA to HEX
   * @param rgba
   */
  public static rgbaToHex(red, green, blue, alpha = 255) {
    let r = red.toString(16);
    let g = green.toString(16);
    let b = blue.toString(16);
    let a = alpha.toString(16).substring(0, 2);

    if (a.length < 2) a = `0${a}`;
    if (r.length < 2) r = `0${r}`;
    if (g.length < 2) g = `0${g}`;
    if (b.length < 2) b = `0${b}`;
    return `#${r}${g}${b}`;
  }

  static trim(str) {
    return str.replace(/^\s+|\s+$/gm, '');
  }

  /**
   * RGB to HSL
   * @param _r
   * @param _g
   * @param _b
   * @returns
   */
  public static rgbToHsl(_r: number, _g: number, _b: number) {
    const r = _r / 255;
    const g = _g / 255;
    const b = _b / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h;
    let s;
    const l = (max + min) / 2;
    if (max === min) {
      h = 0;
      s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
        default:
          break;
      }
      h /= 6;
    }
    return [h, s, l];
  }

  /**
   * HSL to RGB
   * @param h
   * @param s
   * @param l
   */
  public static hslToRgb(h, s, l) {
    const C = (1 - Math.abs(2 * l - 1)) * s;
    const H_ = h / 60;
    const X = C * (1 - Math.abs((H_ % 2) - 1));
    let R1;
    let G1;
    let B1;
    if (h === undefined || Number.isNaN(h) || h === null) {
      R1 = 0;
      G1 = 0;
      B1 = 0;
    } else if (H_ >= 0 && H_ < 1) {
      R1 = C;
      G1 = X;
      B1 = 0;
    } else if (H_ >= 1 && H_ < 2) {
      R1 = X;
      G1 = C;
      B1 = 0;
    } else if (H_ >= 2 && H_ < 3) {
      R1 = 0;
      G1 = C;
      B1 = X;
    } else if (H_ >= 3 && H_ < 4) {
      R1 = 0;
      G1 = X;
      B1 = C;
    } else if (H_ >= 4 && H_ < 5) {
      R1 = X;
      G1 = 0;
      B1 = C;
    } else if (H_ >= 5 && H_ <= 6) {
      R1 = C;
      G1 = 0;
      B1 = X;
    }
    const m = l - C / 2;
    let R = (R1 + m) * 255;
    let G = (G1 + m) * 255;
    let B = (B1 + m) * 255;
    R = Math.round(R);
    G = Math.round(G);
    B = Math.round(B);
    return { r: R, g: G, b: B };
  }

  /**
   * decimalカラーをRGBに変換
   * @returns string
   */
  public static decimalToRGB(number: number): string {
    const r = (number & 0xff0000) >> 16;
    const g = (number & 0x00ff00) >> 8;
    const b = number & 0x0000ff;
    return `rgb(${b},${g},${r})`;
  }

  /**
   * decimalカラーをHEXに変換
   * @param number
   * @returns
   */
  public static decimalToHEX(number: number): string {
    let r = ((number & 0xff0000) >> 16).toString(16);
    let g = ((number & 0x00ff00) >> 8).toString(16);
    let b = (number & 0x0000ff).toString(16);

    if (r.length < 2) r = `0${r}`;
    if (g.length < 2) g = `0${g}`;
    if (b.length < 2) b = `0${b}`;

    return `#${b}${g}${r}`;
  }

  /**
   * decimalカラーをHEX8に変換
   * @param number
   * @returns
   */
  public static decimalToHEX8(number: number): string {
    const hex: string = number.toString(16);
    const a = hex.substring(0, 2);
    const r = hex.substring(2, 4);
    const g = hex.substring(4, 6);
    const b = hex.substring(6, 8);

    return `#${b}${g}${r}${a}`;
  }

  /**
   * HEXカラーをDECIMALに変換
   * @returns number
   */
  public static HEXtoDecimal(_hex: string): number {
    let hex: string = _hex;
    if (hex.charAt(0) === '#') hex = hex.substring(1, 7);
    const r = hex.substring(0, 2);
    const g = hex.substring(2, 4);
    const b = hex.substring(4, 6);
    const color = b + g + r;
    return parseInt(color, 16);
  }
}
